import { ActionTree } from "vuex";
import API from "@/axios";
import { RootState } from "@/store/types";
import { SelfieState, FetchDirectionPayload } from "../types";

const actions: ActionTree<SelfieState, RootState> = {
  async fetchTurnDirection({ commit }, payload: FetchDirectionPayload) {
    const { applicantId, publicKey } = payload;
    return API.post(`/applicants/${applicantId}/instructions`, {
      "Content-Type": "multipart/form-data",
      publicKey: publicKey,
    }).then((res) => {
      if (res.data) {
        const { turnDirection } = res.data.data;
        if (turnDirection) {
          commit("setTurnDirection", turnDirection);
        }
      }
    });
  },
};

export default actions;
